module.exports = __webpack_public_path__ + "media/images/gm_icon04_on-a3190260c29cec1b8eff92720bc9adc9.png";